import { ShipmentType } from "../enums/_index";
import { ShipmentUpdate } from "../shipments/shipment-update";

export class TruckUpdate extends ShipmentUpdate {

    public driverId     : number|undefined = undefined;
    
    public tractorId : number|undefined = undefined;
    
    public trailerId    : number|undefined = undefined;

    constructor() {
        super();
        this.type = ShipmentType.Truck;
    }

}
